import { SESSION_TYPES } from '@medflex/utils/constants';
import makeApiRequest from '../../../api/makeApiRequest';

export const TYPE = 'sessionMeetings';

export const STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  ERROR: 'error',
  SUCCESS: 'success',
};

const sessionMeeetings = {
  name: TYPE,
  state: {
    meetings: [],
    filters: [],
    status: 'idle',
  },
  reducers: {
    onLoaded(state, { meetings, filters }) {
      return {
        ...state,
        meetings,
        filters,
        status: STATUS.SUCCESS,
      };
    },

    onLoading(state) {
      return {
        ...state,
        status: STATUS.LOADING,
      };
    },

    onError(state) {
      return {
        ...state,
        status: STATUS.ERROR,
      };
    },

    'sessions/onUpdated': (state, { sessions }) => {
      return {
        ...state,
        meetings: state.meetings.map(meeting => {
          const updatedSession = sessions.find(session => session.id === meeting.id);
          return updatedSession || meeting;
        }),
      };
    },
  },
  effects(dispatch) {
    return {
      async load(filters, { oidcSession }) {
        dispatch.errors.remove({ realm: TYPE, type: 'load' });
        this.onLoading();

        const { userIds = [], time = [], query = '' } = filters || {};
        const searchParams = new URLSearchParams();
        searchParams.set('type', SESSION_TYPES.MEETING);
        if (userIds.length) searchParams.set('userIds', userIds);
        if (time.length) searchParams.set('time', time);
        if (query.length) searchParams.set('query', query);
        const url = `/sessions?${searchParams}`;
        const [request] = makeApiRequest({ url, method: 'get' }, oidcSession);
        const { error, data } = await request;
        if (!error) {
          this.onLoaded({ meetings: data.data, filters });
        } else {
          this.onError();
          dispatch.errors.add({
            realm: TYPE,
            type: 'load',
            error: new Error(`Failed to load sessions: ${error}`),
          });
        }
      },
    };
  },
  messageListeners: {
    SESSIONS_MODIFIED({ state }) {
      const { [TYPE]: sessionMeetings } = state;
      this.load(sessionMeetings.filters);
    },
    SESSIONS_CREATED({ state }) {
      const { [TYPE]: sessionMeetings } = state;
      this.load(sessionMeetings.filters);
    },
  },
};

export default sessionMeeetings;
